import React from "react"
import { FloatingActionButton, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import DeleteIcon from "material-ui/svg-icons/action/delete"
import TableActionBar from "../layout/TableActionBar"
import PositionsTable from "./PositionsTable"
import AddPositionDialog from "./AddPositionDialog"
import strings from "../../localization/strings"
import { IPayrollPayGroupData, IPosition } from "../../models"
import autobind from "class-autobind"
import AppStateStore from "../../stores/AppStateStore"
import _ from "lodash"
import { red500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"

interface IProps {
    loading?: boolean
    readonly?: boolean
    // if true, we will not show the Bill column. for examle Employee can not see BillInformation
    hideBill?: boolean
    hideTableActionBarTitle?: boolean
    // it true, it's AccountPositionDefinition
    isDefinition?: boolean
    // for example, if add the job position, it "client positions"
    usablePositionLabel?: string
    positions: IPosition[]
    usablePositions: IPosition[]
    addButtonRight?: number
    addButtonTop?: number
    handleAdd(position: IPosition, cb: Function): void
    handleUpdate(position: IPosition, cb: Function): void
    handleDelete(positions: IPosition[], cb: Function): void

    hideAddButton?: boolean

    //we need isEmployeePosition for ForceAccountPositon
    isEmployee?: boolean
    //we need employee payroll to define employee->position->paytypes
    payrollPayGroupData?: IPayrollPayGroupData

    //we need it for UI changing on AddUserDialog
    isDialog?: boolean
}
interface IState {
    searchText: string
    positions: IPosition[],
    openAddPositionDialog: boolean
    editPosition: IPosition
    selectedPositions: IPosition[]
}

export default class Positions extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            searchText: "",
            positions: this.sortPositions(props.positions) || [],
            openAddPositionDialog: false,
            editPosition: null,
            selectedPositions: []
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.positions, nextProps.positions) &&
            this.setState({
                searchText: "",
                positions: this.sortPositions(nextProps.positions) || [],
                selectedPositions: []
            })
    }

    sortPositions(positions: IPosition[]) {
        return positions ?
            positions.sort((a, b) => {
                const nameA = a.Name && a.Name.toUpperCase()
                const nameB = a.Name && b.Name.toUpperCase()
                if (nameA < nameB) {
                    return -1
                }
                if (nameA > nameB) {
                    return 1
                }
                return 0
            }) :
            []
    }

    render() {
        const filteredPositions = this.state.positions.filter(item => item.Name.toLowerCase().includes(this.state.searchText.toLowerCase()))
        const isDialogDeleteIcon = this.props.isDialog && this.state.selectedPositions.length > 0
        return (
            <div style={{ position: "relative" }}>
                {!this.props.readonly && !this.props.hideAddButton &&
                    <FloatingActionButton
                        data-intercom-target={"menu-Employees-Positions-Btn-Add"}
                        className="fixed-add"
                        secondary={!isDialogDeleteIcon}
                        style={{
                            top: this.props.isDialog ? 30 : this.props.addButtonTop !== undefined ? this.props.addButtonTop : -45,
                            right: this.props.isDialog ? 10 : this.props.addButtonRight !== undefined ? this.props.addButtonRight : 50,
                            zIndex: 998
                        }}
                        onTouchTap={() => isDialogDeleteIcon ?
                            AppStateStore.setConfirmDialogContent({
                                content: strings.Are_you_sure_you_want_to_delete_the_selected_position,
                                confirm: () =>
                                    this.props.handleDelete(this.state.selectedPositions, null)
                            }) :
                            this.setState({ openAddPositionDialog: true })
                        }
                    >
                        {isDialogDeleteIcon ?
                            <DeleteIcon /> :
                            <ContentAdd />
                        }
                    </FloatingActionButton>
                }
                <div>
                    {!this.props.isDialog &&
                        <TableActionBar
                            title={!this.props.hideTableActionBarTitle && ( checkPositionFieldAvailable('plural') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel :strings.Positions) }
                            rowSelectionCount={this.state.selectedPositions.length}
                            singleSelectedMessage={strings.Position}
                            multipleSelectedMessage={strings.Positions_selected}
                            onSearch={searchText => this.setState({ searchText })}
                            searchText={this.state.searchText}
                            onDeleteClick={() =>
                                AppStateStore.setConfirmDialogContent({
                                    title: strings.Delete_Selected_Position,
                                    content: strings.Are_you_sure_you_want_to_delete_the_selected_position,
                                    confirm: () => {
                                        AppStateStore.setProgressSnackbarContent("loading")
                                        this.props.handleDelete(this.state.selectedPositions, () => AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted))
                                    }
                                })
                            }
                        />
                    }
                    {this.props.loading ?
                        <div className="spinner"><CircularProgress /></div> :
                        !this.props.isDialog && filteredPositions.length === 0 ?
                            <div>
                                <h2 style={{ textAlign: "center", marginTop: 25 }}                                    >
                                {checkPositionFieldAvailable('plural') ? `No ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel} found` : strings.No_Positions_found}
                                </h2>
                            </div> :
                            <div>
                                <PositionsTable
                                    readonly={this.props.readonly}
                                    hideBill={this.props.hideBill}
                                    positions={filteredPositions}
                                    selectedPositions={this.state.selectedPositions}
                                    isDialog={this.props.isDialog}
                                    handleSelect={selectedPositions => !this.props.readonly && this.setState({ selectedPositions })}
                                    handleEdit={editPosition => this.setState({ editPosition, openAddPositionDialog: true })}
                                />
                                {this.props.isDialog && filteredPositions.length === 0 &&
                                    <div style={{ textAlign: "center", marginTop: 25, color: red500 }}>
                                        {/* {strings.No_Positions_found} */}
                                        {checkPositionFieldAvailable('plural')  ?`No ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel} found` : strings.No_Positions_found}
                                    </div>
                                }
                            </div>
                    }
                </div>
                {this.state.openAddPositionDialog &&
                    <AddPositionDialog
                        readonly={this.props.readonly}
                        isEmployee={this.props.isEmployee}
                        isDefinition={this.props.isDefinition}
                        usablePositionLabel={this.props.usablePositionLabel}
                        usablePositions={this.props.usablePositions}
                        existPositions={this.state.positions}
                        editPosition={this.state.editPosition}
                        onRequestClose={() => this.setState({ openAddPositionDialog: false, editPosition: null })}
                        onRequestSave={position => {
                            !this.props.isDialog &&
                                AppStateStore.setProgressSnackbarContent("loading")
                            this.state.editPosition ?
                                this.props.handleUpdate(position, () => AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)) :
                                this.props.handleAdd(position, () => AppStateStore.setProgressSnackbarContent(strings.Successfully_added))
                        }}
                        payrollPayGroupData={this.props.payrollPayGroupData}
                    />
                }
            </div>
        )
    }
}
